import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';

import render from '../ReduxForm/renderField';

const messages = defineMessages({
  selectTimespan: {
    id: 'dashboard.selectTimespan',
    defaultMessage: 'Select Timespan',
    description: 'Text for timespan selection',
  },
  filter: {
    id: 'dashboard.filter',
    defaultMessage: 'Filter',
    description: 'Text for filter label',
  },
});

class TimeSelectionForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    errors: [],
  };

  render() {
    const { errors, intl, handleSubmit } = this.props;
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <fieldset>
            <Row>
              <Col xs={12} md={8} lg={6}>
                <Field
                  id="time"
                  name="time"
                  placeholder={intl.formatMessage(messages.selectTimespan)}
                  component={render.renderSelectAlt}
                  options={[
                    { value: 'Last Day', label: 'Last Day' },
                    { value: 'Last 30 Days', label: 'Last 30 Days' },
                    { value: 'Last Year', label: 'Last Year' },
                    { value: 'This Month', label: 'This Month' },
                    { value: 'This Year', label: 'This Year' },
                  ]}
                />
              </Col>
              <Col xs={12} md={4} lg={6}>
                <div className="btn-group" style={{ display: 'inline-block' }}>
                  <button type="submit" className="btn btn-primary">
                    <FormattedMessage {...messages.filter} />
                  </button>
                </div>
              </Col>
            </Row>
            <div>
              {errors.length === 0 ? null : (
                <ul style={{ padding: '0', listStyleType: 'none' }}>
                  {errors.map(err => (
                    <li key={err} className="bg-danger">
                      {err}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'timeSelectionForm',
  pure: false, // this is necessary to trigger form re-renders if the locale changes
})(injectIntl(TimeSelectionForm));
